import React from "react";
import { Navigate } from "react-router-dom";

import { useIsAdmin } from "hooks/useIsAdmin";

/**
 * Route guard that only renders children for admin users.
 * Shows nothing while the admin check is loading, then redirects non-admins.
 */
const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAdmin, isLoading } = useIsAdmin();

  if (isLoading) {
    return null;
  }

  if (!isAdmin) {
    return <Navigate to="/muggleTestV0/dashboard" replace />;
  }

  return <>{children}</>;
};

export { AdminRoute };
